module.exports = __webpack_public_path__ + "static/media/logo_blue.44f2fae8.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/logos/logo_blue.png
// module id = 2844
// module chunks = 0